<template>
  <div class="item-activate">
    <div class="container">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ItemActivate',
  mounted () {
    document.title = 'Gluo - Aktivera annons'

    axios.put(process.env.VUE_APP_API_ENDPOINT + '/actions/activate/' + this.$route.params.token)
    .then(response => {
      this.$router.push({
        name: 'item-view',
        params: {
          slug: response.data.slug,
          id: response.data.id
        }
      })
    })
    .catch(() => {
      this.$router.push('/')
    })
  }
}
</script>

<style lang="scss" scoped>
.loader {
  margin-top: 128px;
}
</style>
